module.exports = __webpack_public_path__ + "img/ic_empty.ee208617.svg";